<template>
  <div id="app" :key="Date.parse(new Date())/1000">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',

  data () {
    return {
      theme: ['theme1', 'theme2', 'theme3', 'theme4', 'theme5']
    }
  },

  methods: {
    // 更换主题
    changeTheme(theme) {
      document.body.className = theme;
    },

    // 主题存储
    setTheme() {
      document.querySelector('meta[property="og:locale"]').setAttribute('content', this.langConfig.txtLang[this.langConfig.curLang].language);
      document.querySelector('meta[property="og:url"]').setAttribute('content', this.langConfig.txtLang[this.langConfig.curLang].LOGO_TXT);

      const host = window.location.host;
      let _thema = this.common.GetQueryString('theme');
      if(_thema == 'undefined'){
        _thema = this.common.getCookie('theme');

        if(typeof(_thema) == 'undefined' || _thema == null || !this.theme.includes(_thema)){
          _thema = 'theme1';
        }

        if(host.indexOf('kqbd') != -1){
          _thema = 'theme5';
        }
      }else{
        this.common.setCookie('theme', _thema);
      }

      this.changeTheme(_thema);
      
    }
  },

  mounted(){
    this.setTheme();
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ./src/App.vue